import { useMemo } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { AutomationFormValues } from '~/components/automations/automationSchema'
import { getBridgeTokenType } from '~/constants/addresses'
import { useActiveOrg } from '~/hooks/org'
import { Address } from '~/utils/address'

export const useSelectedBankAccount = () => {
  const { control } = useFormContext<AutomationFormValues>()
  const destinationAddress = useWatch({ control, name: 'destinationAddress' })
  const { org } = useActiveOrg()

  return useMemo(() => {
    if (!destinationAddress || !org?.bridge?.externalAccounts) return undefined

    return org.bridge.externalAccounts.find(
      (account) =>
        Address.equal(account.liquidationAddress, destinationAddress) &&
        getBridgeTokenType(
          account.liquidationChainId,
          Address.format(account.liquidationToken),
        ) === 'usdc',
    )
  }, [destinationAddress, org?.bridge?.externalAccounts])
}
